<template>
  <div class="outer" :class="isSmallScreen ? 'small' : ''">
    <div
      class="main"
      :style="{ 'background-image': `url(${getImageUrl()})` }"
      @click="openOfficial"
    >
      <div class="title">{{ comName }}</div>
      <img src="@/assets/img/icon/point.png" alt="" />
    </div>
    <!-- 四个div分别为四个角上的div -->
    <div class="lt"></div>
    <div class="rt"></div>
    <div class="rb"></div>
    <div class="lb"></div>
  </div>
</template>
  
<script>
export default {
  name: "InfoWindow",
  props: {
    data: Object,
  },
  data() {
    return {
      comName: "",
      isSmallScreen: false,
    };
  },
  mounted() {
    this.comName = this.data.full_name;
    if (window.innerHeight < 923) {
      this.isSmallScreen = true;
    }
  },
  methods: {
    getImageUrl() {
      let name = "";
      if (this.data.name == "滁州") {
        name = "chuzhou.png";
      } else if (this.data.name == "嘉兴") {
        name = "jiashan.png";
      } else if (this.data.name == "宿迁") {
        name = "suqian.png";
      } else if (this.data.name == "徐州") {
        name = "xuzhou.png";
      } else if (this.data.name == "钦州") {
        name = "guangxi.png";
      } else if (this.data.name == "测绘") {
        name = "cehui.png";
      } else if (this.data.name == "南通") {
        name = "rongxin.png";
      } else if (this.data.name == "北京") {
        name = "xhc.png";
      } else if (this.data.name == "重庆") {
        name = "cqyx.jpg";
      } else if (this.data.name == "高新") {
        name = "gaoxin.png";
      } else {
        name = "suzhou.png";
      }
      return require(`@/assets/img/classic/comimg/${name}`);
    },
    openOfficial() {
      if (this.data.name == "重庆") {
        window.open("https://www.cqdpark.com/#/");
      }
    },
  },
};
</script>
  
<style lang="scss" scoped>
.outer {
  position: absolute;
  bottom: 45px;
  border: 1px dashed #00d3e7;
  width: calc(100% - 10px);
  height: 154px;
  border-radius: 5px;
  animation: animate3 2s linear infinite;
}
.small {
  // height: 360px;
  height: 254px;
  .title {
    font-size: 14px;
    padding: 0 10px;
    line-height: 60px;
  }
}
@keyframes animate3 {
  0% {
    border-image: linear-gradient(#c8c8e6, #00d3e7) 20 20;
  }
  50%,
  100% {
    border-image: linear-gradient(#00d3e7, #c8c8e6) 20 20;
  }
}
.main {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
  position: relative;
  img {
    display: block;
    position: absolute;
    bottom: -45px;
    left: 44%;
    z-index: 99;
    width: 20px;
  }
}
.title {
  font-size: 15px;
  text-align: center;
  width: auto;
  padding: 0 10px;
  line-height: 40px;
  background: rgba(4, 27, 46, 0.7);
  border-radius: 4px 4px 0px 0px;
  color: #fff;
}
.lt,
.rt,
.rb,
.lb {
  width: 10px;
  height: 10px;
  position: absolute;
}
.lt {
  border-top: 3px solid #00d3e7;
  border-left: 3px solid #00d3e7;
  left: 0;
  top: 0;
}
.rt {
  border-top: 3px solid #00d3e7;
  border-right: 3px solid #00d3e7;
  right: 0;
  top: 0;
}
.rb {
  border-bottom: 3px solid #00d3e7;
  border-right: 3px solid #00d3e7;
  right: -0;
  bottom: -0;
}
.lb {
  border-bottom: 3px solid #00d3e7;
  border-left: 3px solid #00d3e7;
  left: 0;
  bottom: 0;
}
</style>
  